module.exports = __webpack_public_path__ + "static/media/2.f08aa087.jpg";